import LoadingAnimationIcon from '@/components/icons/loading-animation-icon';
import { Button } from '@/components/ui/button';
import useModal from '@/hooks/useModal';
import { cn } from '@/lib/utils';
import { ThemeColorSchemeType } from '@/stores/builder';
import { usePickupInStore } from '@/stores/pickup-in-store';
import { MapPin } from 'lucide-react';
import { shallow } from 'zustand/shallow';

type ButtonAlmostThereProps = {
  orderId?: string;
  colorScheme?: ThemeColorSchemeType;
  modalNotify: ReturnType<typeof useModal>;
  setOpenModal?: (open: boolean) => void;
};

export function ButtonAlmostThere({
  orderId,
  colorScheme,
  modalNotify,
  setOpenModal,
}: ButtonAlmostThereProps) {
  const { getStateByOrder, getCooldownByOrder } = usePickupInStore(
    (state) => ({
      getStateByOrder: state.getStateByOrder,
      getCooldownByOrder: state.getCooldownByOrder,
    }),
    shallow
  );
  const { isLoading } = getStateByOrder(orderId || '');
  const cooldown = getCooldownByOrder(orderId || '');

  return (
    <>
      <Button
        type='button'
        onClick={() => {
          setOpenModal?.(false);
          modalNotify.open({ orderId });
        }}
        disabled={isLoading || !orderId || cooldown > 0}
        className={cn('w-full gap-2 px-12 py-5 text-sm sm:w-full', !colorScheme && 'theme_button')}
        style={
          colorScheme
            ? {
                backgroundColor: colorScheme?.btnSolidBackgroud,
                color: colorScheme?.btnSolidlabel,
              }
            : {}
        }
        data-testid='almost-there-button-order-customer'
      >
        {isLoading ? (
          <LoadingAnimationIcon color={colorScheme?.btnSolidlabel} />
        ) : (
          <>
            <MapPin className='w-4 h-4' />
            I&apos;m almost there
            {cooldown > 0 && <span className='ml-2 text-sm text-red-500'>({cooldown})</span>}
          </>
        )}
      </Button>
    </>
  );
}
